import type { LineItem, Lot } from 'types';

const itemsByIdCache = new WeakMap<Lot, Map<string, LineItem>>();

export const originalItemsById = (lot?: Lot): Map<string, LineItem> => {
  if (!lot) return new Map();
  let items = itemsByIdCache.get(lot);
  if (!items) {
    items = new Map(lot.line_items.map(item => [String(item.id), item]));
    itemsByIdCache.set(lot, items);
  }
  return items;
};
